import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import DashboardCard from '../../DashboardCard';
import DoughnutMetric from '../DoughnutMetric';

export default function GoalsStatusMetric({ counts }: { counts: graphql.AnalyticsGoalCounts }) {
	const { t } = useTranslation();

	return (
		<DashboardCard description={t('dashboard.metrics.goalStatusCounts.description')}>
			<DoughnutMetric
				data={[
					{
						label: t('dashboard.metrics.goalStatusCounts.completed.label'),
						value: counts.completed,
						color: 'green',
					},
					{
						label: t('dashboard.metrics.goalStatusCounts.pending.label'),
						value: counts.pending,
						color: 'employee',
					},
					{
						label: t('dashboard.metrics.goalStatusCounts.overdue.label'),
						value: counts.overdue,
						color: 'red',
					},
				]}
				byline={t('dashboard.metrics.goalStatusCounts.byline')}
			/>
		</DashboardCard>
	);
}
